import { z } from "zod";

import { DateIsoString } from "@/core/types";
import { CurrencyCodelist } from "@/data/codelists";

import { TimeReportClient } from "./TimeReportClient";
import { TimeReportHiringManager } from "./TimeReportHiringManager";
import { TimeReportStageCodelist } from "./TimeReportStage";
import { TimeReportWorker } from "./TimeReportWorker";

export const TimeReportShort = z.object({
  guid: z.string(),
  systemId: z.string(),

  startDate: DateIsoString,
  endDate: DateIsoString,
  stage: TimeReportStageCodelist,
  version: z.number(),

  totalReportedMinutes: z.number(),
  totalReportedDays: z.number().nullish(),
  totalReportedCost: z.number().nullable(),
  currency: CurrencyCodelist,

  worker: TimeReportWorker,
  client: TimeReportClient,
  hiringManager: TimeReportHiringManager,
});

export type TimeReportShort = z.infer<typeof TimeReportShort>;
